







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class extends Vue {
  @Prop({ type: Boolean })
  public loading: boolean;

  @Prop({type: Boolean, required: true})
  public value: boolean;

  private content!: boolean;

  public created() {
    this.content = this.value;
  }

  public handleChange(value: boolean) {
    this.$emit('change', value);
    this.$emit('input', value);
  }
}
